import { render, staticRenderFns } from "./addMachineType.vue?vue&type=template&id=31bcc598"
import script from "./addMachineType.vue?vue&type=script&lang=js"
export * from "./addMachineType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports